module.exports = __webpack_public_path__ + "media/images/pic/brodno/flying-girl-754b86fbd7bb651ef2096c8016d18cb4.svg";